import React, { Component } from "react";
import Select from "react-select";
import PropTypes from 'prop-types';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";
import { updateISANo } from './redux';

const propTypes = {
  selectedSalesOrder: PropTypes.object
}

const defaultProps = {
  selectedSalesOrder: {},
}

export class IsaEditModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isaNo: props.selectedSalesOrder.IsaNo,
    };
  }
  handleSubmitClick = () => {
    const {
      selectedSalesOrder: {
        SalesOrder_id,
      },
      handleISANoUpdateSuccess
    } = this.props;
    const {
      isaNo
    } = this.state;
    const payload = {
      salesOrderId: SalesOrder_id,
      ISANo: isaNo,
    };
    updateISANo(payload, handleISANoUpdateSuccess);
  }
  render() {
    const {
      isaNo,
    } = this.state;
    return (
      <div>
        <Row style={{ marginBottom: "12px" }}>
          <Col sm={3}>
            <label style={{ float: 'right' }}>
              <Translate value="isa_no" />:
            </label>
          </Col>
          <Col sm={7}>
            <Input 
              type="string"
              value={isaNo}
              onChange={(e) => {
                this.setState({ isaNo: e.target.value })
              }}
            />
          </Col>
        </Row>

        <Row className="centerStyle" style={{ marginTop: "50px" }}>
          <Button
            bsStyle="success"
            onClick={this.handleSubmitClick}
            disabled={!isaNo}
          >
            <Translate value="submit" />
          </Button>
        </Row>
      </div>
    );
  }
}

IsaEditModal.propTypes = propTypes
IsaEditModal.defaultProps = defaultProps

export default IsaEditModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/isaEdit/IsaEditModal.jsx